// extracted by mini-css-extract-plugin
export default {"button-video-wrapper":"ButtonVideo_button-video-wrapper__Ysu6-","video-icon":"ButtonVideo_video-icon__DNa3P"};